<template>

    <div :class=" navbarClasses ">

        <TopHeader></TopHeader>
        <ToolBar></ToolBar>
    </div>
</template>

<script>

    import { mapGetters } from 'vuex';

    import NavIcon from './NavIcon';
    import ToolBar from './ToolBar';
    import TopHeader from './TopHeader';

    export default {

        name: 'top-nav',
        components: {

            NavIcon,
            ToolBar,
            TopHeader
        },
        computed: {

            ...mapGetters({

                isAuth : 'auth/isAuth',
                topHeaderOpen : 'nav/topHeaderOpen'
            }),
            navbarClasses: function (){

                const base = [ 'top-navbar' ];
                base.push( ( this.isAuth ) ? 'solid' : 'transparent' );
                base.push( ( this.topHeaderOpen ) ? 'header-open' : 'header-close' );
                return base.join( ' ' );
            }
        }

    }
</script>

<style scoped>

    .top-navbar {

        display: flex;
        flex-direction: column;
        align-items: center;

        position: fixed;
        width: 100%;
        top: 0; left: 0; right: 0;

        background-color: rgba(32, 27, 27, 1);
        margin: 0;
        z-index: 250;
        transition: top 0.4s ease-in;
    }

    .solid {

        box-shadow: 0px 12px 15px -3px rgba( 0, 0, 0, 0.5 );
        background-color: rgb(32, 27, 27);
        border-bottom: 1px solid rgba( 0, 0, 0, 1 );
    }

    .transparent {

        background-color: transparent;
    }

    .header-open {

        top: 0;
    }
    .header-close {

        top: -175px;
    }

    @media screen and ( max-width: 420px ){

        .transparent {

            box-shadow: 0px 2px 10px 2px rgba( 50, 50, 50, 0.5 );
            background-color: rgba(32, 27, 27, 1);
        }
    }

</style>
